/** Avatar image assets mapping. */

import airbnbImg from "../../assets/airbnb.png";
import blackImg from "../../assets/black.png";
import coinbaseImg from "../../assets/coinbase.png";
import defaultImg from "../../assets/default.png";
import discordImg from "../../assets/discord.png";
import glassImg from "../../assets/glass.png";
import lavenderImg from "../../assets/lavender.png";
import mintImg from "../../assets/mint.png";
import netflixImg from "../../assets/netflix.png";
import rabbitImg from "../../assets/rabbit.png";
import skyImg from "../../assets/sky.png";
import spotifyImg from "../../assets/spotify.png";

/** Map avatar filenames to their imported image URLs. */
export const AVATAR_IMAGE_MAP: Record<string, string> = {
  "airbnb.png": airbnbImg,
  "black.png": blackImg,
  "coinbase.png": coinbaseImg,
  "default.png": defaultImg,
  "discord.png": discordImg,
  "glass.png": glassImg,
  "lavender.png": lavenderImg,
  "mint.png": mintImg,
  "netflix.png": netflixImg,
  "rabbit.png": rabbitImg,
  "sky.png": skyImg,
  "spotify.png": spotifyImg,
};

/** Get the image URL for a user's avatar filename. */
export function getAvatarImageUrl(filename: string): string {
  return AVATAR_IMAGE_MAP[filename] ?? AVATAR_IMAGE_MAP["default.png"]!;
}
